import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Paper, Typography } from "@material-ui/core";
import AutorenewRoundedIcon from "@material-ui/icons/AutorenewRounded";
import useStyles from "@/styles/dashboardStyle";
import { useTranslation } from "@/langs/useTranslation";
import { useQueryParams } from "@/containers/Dashboard";
import { DashboardFailedScheduleDeviceListDatatable } from "@/helpers/dashboardFailedScheduleDeviceListDatatable";

function queryParamsAdapter(params) {
  return {
    groupIds: params.group_ids,
    tagIds: params.tag_ids,
    includeChildCompany: params.hasSubCompanies === 1
  };
}

const FailedScheduleDeviceDatatable = props => {
  const classes = useStyles();
  const tableRef = useRef(null);
  const { t } = useTranslation();
  const [queryParams] = useQueryParams();

  const reloadTable = () => {
    tableRef.current?.reload();
  };

  const getSearchParams = () => {
    return queryParamsAdapter(queryParams);
  };

  useEffect(() => {
    reloadTable();
  }, [queryParams]);

  return (
    <Paper elevation={0}>
      <div className={classes.blockTitle}>
        <Typography
          variant="h6"
          className={classes.cardTitleWrapWithReloadIcon}
        >
          {props.title}
          <AutorenewRoundedIcon
            onClick={reloadTable}
            size="small"
            className={classes.reload_btn}
          />
        </Typography>
        <Link to="/schedule/calendar?viewType=2">
          {t({ defaultMessage: "查看更多 >" })}
        </Link>
      </div>
      <DashboardFailedScheduleDeviceListDatatable
        getSearchParams={getSearchParams}
        ref={tableRef}
      />
    </Paper>
  );
};

export default FailedScheduleDeviceDatatable;
